import $ from 'jquery';
import {getLCP, getCLS, onINP} from 'web-vitals';
import 'styleguide/modules/close-banner.js';
import 'styleguide/modules/countdown.js';
import heartProduct from 'modules/heart-product'

window.bindHeartEvent = heartProduct.initHeart;

$(function(){
    const rcProps = window.rcProps || {};
    const headerProps = rcProps.header || {};
    const accountLoginHref = headerProps.accountLoginHref || '/content/header/accountLogin?signInReturnPage=';
    const headerBannerHref = headerProps.headerBannerHref || '/content/banner/header';
    const headerWebVitals = rcProps.webVitals || {};
    
    heartProduct.initHeart($('.js-favorite-button'));

    //logic for skip link content
    if($("#main-content").length !== 1){
        $(".skip-link").remove();
    }

    function trackCloseAndDisableGlobalBanner() {
        $(".js-close-banner").on('click', function () {
            $.post("/r/ajax/SetRevolveSessionParam.jsp", $.param({
                "key": "rglobalbannerdismiss",
                "value": "disableglobalbanner"
            }), function () {});
    
            if (typeof window.logEngagement === "function") {
                window.logEngagement(window.location.href, "main_global_banner", "close");
            }
            $('#globalTopBannerCarouselMarkup').removeClass('cls-tgb--active');

        });
    }

    $.ajax({
        url: headerBannerHref,
        success: function(data){
            if (data.banner) {
                $('#headerBannerMarkup').html(data.banner);
            }
            if (data.globalTopBannerCarousel) {
                $('#globalTopBannerCarouselMarkup').html(data.globalTopBannerCarousel);
                updateClsCookieObject("topGlobalBanner", 1);
            } else {
                updateClsCookieObject("topGlobalBanner", 0);
                $("#globalTopBannerCarouselMarkup").removeClass('cls-tgb--active');
            }
            if (data.cookieBanner) {
                $('#cookieTopBannerMarkup').html(data.cookieBanner);
                updateClsCookieObject("cookieTopGlobalBanner", 1);
            } else {
                updateClsCookieObject("cookieTopGlobalBanner", 0);
                $("#cookieTopBannerMarkup").removeClass('cls-cpgb--active');
            }
            $('.js-slideshow').each(function() {
                var $bannerSlideshow = $(this);
                const language = $('html').attr('lang');
                let rtlBool = language === "ar";
                if ($bannerSlideshow.children('.banner--slider-list__item').length > 1) {
                    $bannerSlideshow.slick({
                        autoplay: true,
                        autoplaySpeed: 6000,
                        prevArrow: $bannerSlideshow.siblings('.banner__slick-prev'),
                        nextArrow: $bannerSlideshow.siblings('.banner__slick-next'),
                        rtl: rtlBool
                    });
                    $('.banner__slick-next, .banner__slick-prev').on('click', () => {
                        $bannerSlideshow.slick('slickPause');
                    });
                } else {
                    $('.banner__slick-next, .banner__slick-prev').hide();
                    $('.banner--slider-list').show();
                }
            });
            // The global top banner is AJAX-injected after the page-level countdown init in
            // modules.js has already run, so initialize the IRC expiry countdown here.
            $('#globalTopBannerCarouselMarkup').find('.js-countdown').countdown();
            trackCloseAndDisableGlobalBanner();
            $('.js-close-banner').closeBanner();
        }
    });
    
    $.ajax({
        url: accountLoginHref,
        success: function(data){
            $('#header-account-login').html(data);
            $('.js-dropdown').dropdown();
        }
    });

    if (headerWebVitals.increaseCounterAndCheck === 'true' && headerWebVitals.collectEndPoint.length) {
        window.addEventListener('load', function () {

            var queue = new Set();

            function addToQueue(metric) {
                queue.add({
                    metricId: metric.id,
                    name: metric.name,
                    value: metric.value,
                    delta: metric.delta,
                    address: window.location.href
                });
            }

            function flushQueue() {
                if (queue.size > 0) {
                    var dataArray = [];
                    queue.forEach(function (value) {
                        dataArray.push(value);
                    });
                    const body = JSON.stringify(dataArray);

                    (navigator.sendBeacon && navigator.sendBeacon(headerWebVitals.collectEndPoint, new Blob([body], {type: 'application/json'}))) ||
                    fetch(headerWebVitals.collectEndPoint, {body, method: 'POST', keepalive: true, headers: new Headers({'content-type': 'application/json'})});

                    queue.clear();
                }
            }

            getCLS(addToQueue);
            getLCP(addToQueue);
            onINP(addToQueue);

            // Collect metrics on common browsers
            addEventListener('visibilitychange', function () {
                if (document.visibilityState === 'hidden') {
                    flushQueue();
                }
            });

            // Collect metrics on Safari browser
            addEventListener('pagehide', flushQueue);
        });
    }

    if (rcProps.logClientMetrics === 'true') {
        var observer = new PerformanceObserver(navigationCallback);
        observer.observe({entryTypes: ["navigation"]});
    }

    function navigationCallback(list, observer) {
        list.getEntries().forEach(function (performance) {
            $.ajax({
                type: "POST",
                contentType: "application/json",
                url: rcProps.clientMetricsEndpoint,
                data: JSON.stringify({
                    domLoadTime: Math.round(performance.domContentLoadedEventEnd - performance.startTime),
                    pageLoadTime: Math.round(performance.loadEventEnd - performance.startTime),
                    networkTime: Math.round(performance.responseStart - performance.startTime),
                    address: performance.name,
                }),
                dataType: 'json'
            });
        });
    }

    function calculateMainNavGap() {
        const flexItems = document.querySelectorAll('.nav__wrapper > .nav__item');

        if (flexItems.length < 2) return 0;

        const firstRect = flexItems[0].getBoundingClientRect();
        const secondRect = flexItems[1].getBoundingClientRect();

        const gap = secondRect.left - firstRect.right;

        // Set CSS custom property
        document.documentElement.style.setProperty('--nav-gap', gap + 'px');

        return gap;
    }

    calculateMainNavGap();
    window.addEventListener('resize', throttle(() => calculateMainNavGap(), 100));
    
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/index.js